import { FC } from 'react'
import { ColorOptions, FontSizeOptions } from '../../theme/UiThemeProvider'
import { Box, BoxProps } from '../BoxNew'
import { Text, TextProps } from '../TextNew'
import { IconIds } from './IconIds'

export { IconIds }

export type IconOptions = keyof typeof IconIds

const iconTypes = {
  primary: {
    color: 'BRAND_PRIMARY_WHITE',
  } as TextProps,
  secondary: {
    color: 'BRAND_PRIMARY_ACTION',
  } as TextProps,
  selectable: {
    style: (colorTheme: ColorOptions, size: FontSizeOptions | number) => ({
      color: colorTheme,
      fontSize: size,
    }),
  },
}

export interface IconProps {
  id: IconOptions
  size?: FontSizeOptions | number
  color?: ColorOptions | Array<ColorOptions>
  type?: keyof typeof iconTypes | Array<keyof typeof iconTypes>
  hide?: boolean
  weight?: 'normal' | 'dense' | Array<'normal' | 'dense'>
  enableDot?: boolean
}

export const Icon: FC<IconProps> = ({
  id,
  size = 'MEDIUM',
  color = 'TEXT_PRIMARY',
  type,
  hide = false,
  weight = 'normal',
  enableDot = false,
}) => {
  if (hide) {
    return null
  }

  return (
    <>
      <Text
        fontFamily="JioMoney"
        {...iconTypes[type as keyof typeof iconTypes]}
        fontSize={size}
        color={color}
        selectable={false}
        weight={weight}>
        {IconIds[id]}
      </Text>
      {enableDot && <Box {...styles.dot} />}
    </>
  )
}

const styles = {
  dot: {
    position: 'absolute',
    top: 0,
    left: 10,
    padding: 4,
    borderRadius: 50,
    backgroundColor: 'BLUE',
  } as BoxProps,
}
